import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Spacer, Text, Box} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import PoweredBy from '../../../components/PoweredBy'
import BillTo from './BillTo'
import SupplierLogo from './SupplierLogo'
import {LetterHead} from '../../../utils/address'
import AddressPropTypes from '../../../../utils/propTypes/address'

const Header = ({name, phone, email, address, supplier}) => {
  const {t} = useTranslation('payerStatements')

  return (
    <Flex direction={{base: 'column', md: 'row'}} fontSize="xs">
      <Box>
        <Flex direction={{base: 'column', md: 'row'}}>
          <Box mb={{base: 4, md: 0}}>
            <Flex direction={{base: 'column', sm: 'row'}}>
              <SupplierLogo logo={supplier.logo} name={supplier.name} />
              <Spacer />
              <Box display={{sm: 'block', md: 'none'}}>
                <PoweredBy />
              </Box>
            </Flex>
          </Box>
          <Box>
            {supplier.address &&
              LetterHead(supplier.address).map((line) => (
                <Text key={line}>{line}</Text>
              ))}
            <Text>
              {t(`businessNumberTypes.${supplier.business.numberType}`)}:{' '}
              {supplier.business.number}
            </Text>
          </Box>
        </Flex>
        <Box>
          <Box display={{base: 'block', md: 'none'}} pt={4}>
            <BillTo name={name} phone={phone} email={email} address={address} />
          </Box>
        </Box>
      </Box>
      <Spacer />
      <Box>
        <Box display={{base: 'none', md: 'block'}}>
          <Box justifySelf="right">
            <PoweredBy />
          </Box>
          <Box data-testid="header-bill-to-desktop">
            <BillTo name={name} phone={phone} email={email} address={address} />
          </Box>
        </Box>
      </Box>
    </Flex>
  )
}

Header.defaultProps = {
  address: null,
  supplier: {
    logo: null,
    address: null,
  },
}

Header.propTypes = {
  name: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  address: AddressPropTypes,
  supplier: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logo: PropTypes.string,
    business: PropTypes.shape({
      number: PropTypes.string.isRequired,
      numberType: PropTypes.string.isRequired,
    }).isRequired,
    address: AddressPropTypes,
  }),
}

export default Header
